import { Component, OnDestroy, OnInit } from '@angular/core';

import { UserFacade } from './main/UserFacade';
import { AuthService } from '@auth0/auth0-angular';
import { Subject, takeUntil } from 'rxjs';
import { NgcCookieConsentService, NgcStatusChangeEvent } from 'ngx-cookieconsent';

// declare gtag function for Google Analytics
declare function gtag(command: string, type: string, content: object): void;

@Component({
  selector: 'cimg-ui-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();

  constructor(private userFacade: UserFacade,
              public auth: AuthService,
              public cookiesService: NgcCookieConsentService) {}

  ngOnInit(): void {
    this.initCookieConsent();
    this.auth.user$.subscribe((user) => {
      if (user) {
        this.userFacade.setUser(user);
      }
    });
  }

  initCookieConsent(): void {
    this.cookiesService.statusChange$.pipe(takeUntil(this.unsubscribe$)).subscribe(
      (event: NgcStatusChangeEvent) => {
        const consentMode = {
          functionality_storage: event.status === 'allow' ? 'granted' : 'denied',
          security_storage: event.status === 'allow' ? 'granted' : 'denied',
          ad_storage: event.status === 'allow' ? 'granted' : 'denied',
          analytics_storage: event.status === 'allow' ? 'granted' : 'denied',
          personalization: event.status === 'allow' ? 'granted' : 'denied',
          ad_user_data: event.status === 'allow' ? 'granted' : 'denied',
          ad_personalization: event.status === 'allow' ? 'granted' : 'denied',
          personalization_storage: event.status === 'allow' ? 'granted' : 'denied'
        };

        gtag('consent', 'update', consentMode);
        localStorage.setItem('consentMode', JSON.stringify(consentMode));
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
